// extracted by mini-css-extract-plugin
export var almostBlack = "#333";
export var almostWhite = "#f0f0f0";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var container = "index-module--container--fAuYw";
export var coolGrey = "#e1e2e0";
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var darkGrey = "#4b4d4b";
export var error = "#f66a83";
export var green = "#3dae2b";
export var grey = "#828382";
export var icon = "index-module--icon--DHLkm";
export var iconAndNumberContainer = "index-module--iconAndNumberContainer--DfCVf";
export var lightGreen = "#93d500";
export var lightGrey = "#aba9a9";
export var moduleRoot = "index-module--moduleRoot--T1hmj";
export var number = "index-module--number--MlFte";
export var numberBlockText = "index-module--numberBlockText--ZkL1s";
export var numberBlockTitle = "index-module--numberBlockTitle--pRuFb";
export var numberContainer = "index-module--numberContainer--APzzk";
export var numbersPerRow3 = "index-module--numbersPerRow3--JaDTk";
export var numbersPerRow4 = "index-module--numbersPerRow4--pXF1i";
export var numbersPerRow5 = "index-module--numbersPerRow5--XizpN";
export var numbersPerRow6 = "index-module--numbersPerRow6--aasRy";
export var orange = "#fc9948";
export var paleBlue = "#64a1bb";
export var success = "#1ebc7b";
export var title = "index-module--title--DNGFM";
export var titleContainer = "index-module--titleContainer--z9jjk";
export var value = "index-module--value--pKg2U";
export var warning = "#ffeda0";
export var white = "#fff";
export var year = "index-module--year--yCxg1";
export var yellow = "#fbc900";